/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ResourceProcessingReconcileParams } from './resourceProcessingReconcileParams';

/**
 * Request model for the resource-processing reconciliation job
 */
export interface RunResourceProcessingReconcileJobRequest {
  type: 'resource_processing_reconcile';
  params: ResourceProcessingReconcileParams;
  allowOverlappingJobs?: boolean;
}
